"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var FilterRubric = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterRubric, _React$Component);

  function FilterRubric(props) {
    var _this;

    _classCallCheck(this, FilterRubric);

    _this = _possibleConstructorReturn(this, (FilterRubric.__proto__ || Object.getPrototypeOf(FilterRubric)).call(this, props));
    _this.openRubric = _this.openRubric.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FilterRubric, [{
    key: "openRubric",
    value: function openRubric() {
      this.props.onRubricClick();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.t,
          item = _this$props.item;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.props.showTitle && /*#__PURE__*/_react.default.createElement("strong", {
        className: "filter-menu-item filter-menu-item-title"
      }, t('product')), /*#__PURE__*/_react.default.createElement("li", {
        key: item.id,
        onClick: this.openRubric,
        className: "filter-menu-item filter-menu-item-rubric"
      }, /*#__PURE__*/_react.default.createElement("label", null, item.name)));
    }
  }]);

  return FilterRubric;
}(_react.default.Component);

FilterRubric.propTypes = {
  t: _propTypes.default.func,
  title: _propTypes.default.string,
  onRubricClick: _propTypes.default.func,
  product: _propTypes.default.array,
  item: _propTypes.default.shape({
    id: _propTypes.default.any,
    name: _propTypes.default.string,
    parameterName: _propTypes.default.string,
    value: _propTypes.default.string
  }),
  showTitle: _propTypes.default.bool
};
var _default = FilterRubric;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/hofsearch-filter/lib/filter-rubric.js
// module id = 877
// module chunks = 0